module.exports = __webpack_public_path__ + "static/img/worry-2.3c55fbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/worry-2.png
// module id = pOd4
// module chunks = 1